import { render } from "./privacyPolicy.vue?vue&type=template&id=0efb9577&scoped=true"
import script from "./privacyPolicy.vue?vue&type=script&lang=js"
export * from "./privacyPolicy.vue?vue&type=script&lang=js"

import "./privacyPolicy.vue?vue&type=style&index=0&id=0efb9577&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efb9577"]])

export default __exports__